const storytool = {
	name: "Storytool",
	audio: true,
	connection: false,
	allowMissingISBN: true,
	disableArticles: ["cd", "mp3cd"],
};

export default storytool;
